import React from "react";
import { Card } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { UsergroupAddOutlined } from "@ant-design/icons";
import { Button } from "../../../components";

import { IoFootballOutline } from "react-icons/io5";
import { RiVideoFill } from "react-icons/ri";
import { BiMessageDots, BiSupport } from "react-icons/bi";
import { VscBookmark } from "react-icons/vsc";
import { HiOutlineCake, HiSpeakerphone } from "react-icons/hi";


const SideMenu = () => {
  return (
    <>
      <div>
        <Card className="sidebarCard">
          <div className="flex items-center py-4 sideMenu">
            <IoFootballOutline style={{ fontSize: "20px", color: "#000",marginRight: "15px" }} />
            <Link className="text-md 2xl:text-lg">LiveScores</Link>
          </div>
          <div className="flex items-center py-4 sideMenu">
            <TeamOutlined style={{ fontSize: "20px", color: "#000",marginRight: "15px" }} />
            <Link className="text-md 2xl:text-lg">Connection</Link>
          </div>
          <div className="flex items-center py-4 sideMenu">
            <BiMessageDots style={{ fontSize: "20px", color: "#000",marginRight: "15px" }} />
            <Link className="text-md 2xl:text-lg">Forum</Link>
          </div>
          <div className="flex items-center py-4 sideMenu">
            <RiVideoFill style={{ fontSize: "20px", color: "#000",marginRight: "15px" }} />
            <Link className="text-md 2xl:text-lg">Watch Now</Link>
          </div>
          <div className="flex items-center py-4 sideMenu">
            <VscBookmark style={{ fontSize: "20px", color: "#000",marginRight: "15px" }} />
            <Link className="text-md 2xl:text-lg">Saved Post</Link>
          </div>
          <div className="flex items-center py-4 sideMenu">
            <HiOutlineCake style={{ fontSize: "20px", color: "#000",marginRight: "15px" }} />
            <Link className="text-md 2xl:text-lg">Birthdays</Link>
          </div>
          <div className="flex items-center py-4 sideMenu">
            <HiSpeakerphone style={{ fontSize: "20px", color: "#000",marginRight: "15px" }} />
            <Link className="text-md 2xl:text-lg">News Room</Link>
          </div>
          <div className="flex items-center py-4 sideMenu">
            <BiSupport style={{ fontSize: "20px", color: "#000",marginRight: "15px" }} />
            <Link className="text-md 2xl:text-lg">Support</Link>
          </div>
          <div className="flex items-center py-4 sideMenu">
            <Button
              type="default"
              className="mr-10 button-transparent"
              icon={<UsergroupAddOutlined />}
              title="Create Forum"
              style={{
                borderRadius: "30px",
                borderColor: "#1890ff",
                color: "#1890ff",
              }}
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default SideMenu;
